import { computed } from 'vue';
import { useNow } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';

export const greetingPeriod = date => {
  const hour = date.getHours();
  if (hour < 6) return 'EVENING';
  if (hour < 12) return 'MORNING';
  if (hour < 18) return 'AFTERNOON';
  return 'EVENING';
};

export const useTalkviaBrand = () => {
  const { t } = useI18n();
  const user = useMapGetter('getCurrentUser');
  const now = useNow({ interval: 60000 });
  return computed(() => ({
    name: 'Talkvia',
    icon: '/brand-assets/logo_thumbnail.svg',
    tagline: [
      t(`TALKVIA_GREETING.${greetingPeriod(now.value)}`),
      user.value?.name?.trim().split(/\s+/)[0],
    ]
      .filter(Boolean)
      .join(' '),
  }));
};
